function initExhibitionCarousel() {
  const slides = document.querySelectorAll('.exhibition-slide');
  const nextBtn = document.querySelector('.exhibition-next');
  const prevBtn = document.querySelector('.exhibition-prev');

  if (!slides.length) return;

  let current = 0;

  function updateSlides() {
    slides.forEach((slide, i) => {
      slide.classList.remove('active', 'prev', 'next');
      if (i === current) slide.classList.add('active');
      else if (i === (current - 1 + slides.length) % slides.length) slide.classList.add('prev');
      else if (i === (current + 1) % slides.length) slide.classList.add('next');
    });
  }

  nextBtn?.addEventListener('click', () => {
    current = (current + 1) % slides.length;
    updateSlides();
  });

  prevBtn?.addEventListener('click', () => {
    current = (current - 1 + slides.length) % slides.length;
    updateSlides();
  });

  updateSlides();
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', initExhibitionCarousel);

// Re-initialize when the Shopify editor changes something
document.addEventListener('shopify:section:load', initExhibitionCarousel);